/**
 * Auth behaviour is injected by the app, never imported here: importing the app's session
 * store would be a dependency cycle and would fossilise auth policy into a shared package
 * a second app would then inherit.
 */
export type ApiAuthHooks = {
  /** Current bearer token, or null when anonymous. Injected verbatim as `Authorization: Bearer`. */
  getAccessToken: () => string | null;
  /** Single-flight refresh. Resolves with a fresh bearer token. */
  refresh: () => Promise<string>;
  /**
   * Called only when refresh itself rejects — the app clears session and redirects. A failed
   * replay is never terminal. `cause` is the refresh rejection, for reporting.
   */
  onAuthFailure: (cause: unknown) => void;
};

type ApiConfig = ApiAuthHooks & { baseURL: string };

let config: ApiConfig | null = null;

export function configureApiClient(next: ApiConfig): void {
  config = next;
}

export function getApiConfig(): ApiConfig {
  if (!config) {
    throw new Error(
      'configureApiClient() was not called. The app must configure the API client at boot before any request is issued.',
    );
  }
  return config;
}

/** Test/teardown helper. */
export function resetApiClient(): void {
  config = null;
}
